import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "flex flex-wrap justify-between items-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "divide-y divide-green-1 break-all w-full" }
const _hoisted_4 = { class: "text-xs font-bold hidden @5xl:flex" }
const _hoisted_5 = { class: "text-xs m-xs justify-center items-center flex-none" }
const _hoisted_6 = ["checked", "onClick", "id"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 m-xs w-full" }, "Medikament", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-xl m-xs flex-none" }, "Anzahl", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-textcell m-xs flex-none" }, "Bemerkung", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-longtext m-xs flex-none" }, [
  /*#__PURE__*/_createTextVNode("Zuletzt"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("bestellt")
], -1)
const _hoisted_11 = {
  key: 0,
  class: "w-multiselect m-xs flex-none"
}
const _hoisted_12 = {
  key: 1,
  class: "w-multiselect m-xs flex-none"
}
const _hoisted_13 = {
  key: 2,
  class: "w-multiselect m-xs flex-none"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "w-textcell m-xs flex-none" }, "Notiz", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "w-xxl m-xs flex-none" }, null, -1)
const _hoisted_16 = { class: "m-xs flex-none @5xl:hidden" }
const _hoisted_17 = { class: "m-xs hidden @5xl:flex flex-none" }
const _hoisted_18 = ["checked", "onClick", "id"]
const _hoisted_19 = { class: "m-xs w-xl @5xl:hidden" }
const _hoisted_20 = { class: "m-xs w-full flex-1 @5xl:w-auto" }
const _hoisted_21 = {
  key: 1,
  class: "text-sm text-gray-600"
}
const _hoisted_22 = { class: "m-xs flex-none w-xl hidden @5xl:table-cell" }
const _hoisted_23 = { class: "m-xs flex-none w-textcell text-xs hidden @5xl:table-cell" }
const _hoisted_24 = { class: "m-xs flex-none w-longtext hidden @5xl:table-cell" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 0,
  class: "m-xs flex-none w-multiselect hidden @5xl:table-cell"
}
const _hoisted_27 = {
  key: 1,
  class: "m-xs flex-none w-multiselect hidden @5xl:table-cell"
}
const _hoisted_28 = {
  key: 2,
  class: "m-xs flex-none w-multiselect hidden @5xl:table-cell"
}
const _hoisted_29 = { class: "m-xs flex-none w-textcell text-xs hidden @5xl:table-cell" }
const _hoisted_30 = { class: "m-xs flex-none w-xxl" }
const _hoisted_31 = { class: "flex justify-end items-center" }
const _hoisted_32 = { class: "flex flex-grow-0 justify-between sm:justify-normal items-center" }
const _hoisted_33 = { class: "flex overflow-scroll justify-between" }
const _hoisted_34 = { class: "hidden" }
const _hoisted_35 = { class: "@5xl:flex justify-end items-center" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "w-xs h-xs" }, null, -1)
const _hoisted_37 = {
  key: 0,
  class: "fixed top-0 bottom-0 left-0 right-0 flex items-center justify-center bg-white flex-col bg-opacity-95"
}

import { computed, ref, onMounted, onBeforeUnmount } from "vue";
import UButton from "@/components/UButton.vue";
import {
  Message,
  OrderMedication,
  MessageModelClass,
} from "@/interfaces/message";
import { MessageType } from "@/interfaces/enum/messageType";
import { MedicationOrderStatus } from "@/interfaces/enum/medicationOrderStatus";
import { StorageLocation } from "@/interfaces/enum/StorageLocation";
import RoundedCard from "@/components/RoundedCard.vue";
import DialogCard from "@/components/DialogCard.vue";
import { encryptAndSaveMessage } from "@/helpers/requestHelpers/ordersRequests";
import { updateMessage } from "@/helpers/requestHelpers/ordersRequests";
import { Conversation } from "@/interfaces/conversation";
import OrderMessageHistory from "./OrderMessageHistory.vue";
import { useManagedPatientsStore } from "@/store/managedPatientsStore";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import CoreIcon from "@/components/CoreIcon.vue";
import ReactiveSelect from "@/components/ReactiveSelect.vue";
import LabelButton from "@/components/LabelButton.vue";
import { localeDateString } from "@/helpers/datehelper";
import OrderBoxManagement from "./OrderBoxManagement.vue";
import { useOrdersStore } from "@/store/ordersStore";
import EmptyContainer from "@/components/EmptyContainer.vue";
import SmallTag from "@/components/SmallTag.vue";
import { supabase } from "@/helpers/supabase";
import { statusOfConversation } from "@/helpers/orderhelper";
import { useSessionStore } from "@/store/sessionStore";
import { buildCsvFromSortedOrders } from "@/helpers/csvhelper";
import BarcodeScanner from "./BarcodeScanner.vue";
import { useNotificationStore } from "@/store/notificationStore";
import IconButton from "@/components/IconButton.vue";
import OrderMessageMedicationBoxScanner from "./OrderMessageMedicationBoxScanner.vue";
import { patientString } from "@/helpers/patienthelper";
import OrderMedicationFavorites from "./OrderMedicationFavorites.vue";
import ProgressDot from "@/components/ProgressDot.vue";
import { getNode } from "@formkit/core";
import MedicationInformation from "@/components/MedicationInformation.vue";
import { BaseMedication } from "@/interfaces/medication";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderMessageMedications',
  props: {
    messages: {},
    conversation: {},
    isSender: { type: Boolean },
    isLoadingMedicationInformation: { type: Boolean },
    errorLoadingMedicationInformation: { type: Boolean }
  },
  setup(__props: any) {

const medicationGroups = ref(null);
const medications = ref(null);

const sessionStore = useSessionStore();
const managedPatientsStore = useManagedPatientsStore();

const medicationForm = ref<any>({});
const showMedicationModal = ref<boolean>(false);
const showFavoriteMedicationModal = ref<boolean>(false);
const showBoxModal = ref<boolean>(false);
const confirmSendDraft = ref<boolean>(false);
const showHistoryOf = ref<Message | null>(null);
const showDeletedMedications = ref<boolean>(false);

const selectedMedications = ref<Map<number, boolean>>(new Map());

const loadingMessages = ref<Set<number>>(new Set());

const editMedicationId = ref<number | undefined>(undefined);

const allMessages = computed<Message[]>(() => {
  return Array.from(useOrdersStore().messages?.values() ?? []);
});

const props = __props;

// active smartphone-scanner
let scannerOn = ref<boolean>(false);

// USB/BluetoothMedicationScanner

onMounted(() => {
  window.document.addEventListener("paste", pasteEvent);
});

onBeforeUnmount(() => {
  window.document.removeEventListener("paste", pasteEvent);
});

function pasteEvent(event: ClipboardEvent) {
  if (showMedicationModal.value || showBoxModal.value) return;
  let paste = event.clipboardData?.getData("text") ?? "";

  if (paste.length == 13) {
    selectGtin(paste);
  }
}

function selectGtin(gtin: string) {
  let results = 0;
  let nonSelectedResults = 0;
  let selected = false;
  let selectedMedication: OrderMedication | null = null;
  for (const msg of props.messages) {
    if (
      msg.medication_order &&
      msg.medication_order.gtin == parseInt(gtin) &&
      !msg.medication_order.deleted
    ) {
      results++;
      if (!selectedMedications.value.get(msg.id)) {
        nonSelectedResults++;
        if (!selected) {
          selectedMedications.value.set(msg.id, true);
          selected = true;
          nonSelectedResults--;
          selectedMedication = msg.medication_order;
        }
      }
    }
  }

  useNotificationStore().notifications =
    useNotificationStore().notifications.filter(
      (notification) => notification.customId != "scanner"
    );
  if (selectedMedication) {
    useNotificationStore().notifications.push({
      msg: `Medikament ${selectedMedication.name} ausgewählt. (${
        results - nonSelectedResults
      }/${results} ausgewählt)`,
      type: "success",
      customId: "scanner",
    });
  } else if (results > 0) {
    useNotificationStore().notifications.push({
      msg: `Kein weiteres Medikament ausgewählt. (${
        results - nonSelectedResults
      }/${results} ausgewählt)`,
      type: "warning",
      customId: "scanner",
    });
  } else {
    useNotificationStore().notifications.push({
      msg: `Medikament nicht gefunden`,
      type: "danger",
      customId: "scanner",
    });
  }
}

const patientOptions = computed<Array<{ label: string; value: number }>>(() => {
  let patientOptions: Array<{ label: string; value: number }> = [];

  const label = `Verbrauchsmaterial`;
  const value = 0;
  const cpgObj = { label, value };
  patientOptions.push(cpgObj);

  for (let patient of managedPatientsStore.patients ?? []) {
    if (
      managedPatientsStore.connectedCareProviderGroups
        ?.get(patient.id)
        ?.has(
          props.isSender
            ? props.conversation.receiverCareProviderGroup.id
            : props.conversation.senderCareProviderGroup.id
        ) &&
      patient.currentProfile?.deceased != true
    ) {
      const label = `${patient.currentProfile?.firstName} ${patient.currentProfile?.lastName}`;
      const value = patient.id;
      const patientObj = { label, value };
      patientOptions.push(patientObj);
    }
  }
  return patientOptions;
});

const medicationOrderStatus = MedicationOrderStatus;
const storageLocation = StorageLocation;

function hasAllMedicationSelectedOf(patientId: number) {
  let messages = groupedMessagesByPatient.value.get(patientId);
  if (messages == null || messages.length == 0) return false;
  for (let message of messages ?? []) {
    if (!selectedMedications.value.get(message.id)) return false;
  }
  return true;
}

function selectPatient(event: any, patientId: number) {
  if (event.shiftKey) {
    for (const [patientKey, messages] of groupedMessagesByPatient.value) {
      if (patientKey !== patientId) {
        for (const message of messages ?? []) {
          selectedMedications.value.set(message.id, false);
        }
      } else {
        for (const message of messages ?? []) {
          selectedMedications.value.set(message.id, true);
        }
      }
    }
    if (medicationGroups.value !== null) {
      for (const medicationGroup of medicationGroups.value) {
        if (medicationGroup.id == patientId) {
          medicationGroup.checked = true;
        }
      }
    }
    return true;
  } else {
    let messages = groupedMessagesByPatient.value.get(patientId);
    if (messages == null || messages.length == 0) return false;
    let newValue = !hasAllMedicationSelectedOf(patientId);
    for (let message of messages ?? []) {
      selectedMedications.value.set(message.id, newValue);
    }
    return true;
  }
}

function selectMedication(event: any, message: Message) {
  if (event.shiftKey) {
    for (const [key, value] of selectedMedications.value) {
      if (message.id !== key) {
        selectedMedications.value.set(key, false);
      }
    }
    selectedMedications.value.set(message.id, true);
    if (medications.value !== null) {
      for (const medication of medications.value) {
        if (medication.id == message.id) {
          medication.checked = true;
        }
      }
    }
  } else {
    let currentValue = selectedMedications.value.get(message.id) ?? false;
    selectedMedications.value.set(message.id, !currentValue);
  }
}

async function saveMessage(message: MessageModelClass | Message) {
  return await encryptAndSaveMessage(props.conversation, message);
}
let orderStore = useOrdersStore();
function lastOrdered(patientId: number, medicationName: string) {
  let allMessages = Array.from(orderStore.messages?.values() ?? []);
  let message = allMessages.find((message) => {
    if (message.conversation.id == props.conversation.id) {
      // filter current conv
      return false;
    }
    if (!isConversationSent(message.conversation.id)) {
      // ignore drafts
      // filter current conv
      return false;
    }
    if (!message.medication_order) {
      // only get medication orders
      return false;
    }
    if (message.medication_order.patient_id != patientId) {
      return false;
    }
    if (message.medication_order.deleted) {
      return false;
    }
    if (message.medication_order.name != medicationName) {
      return false;
    }
    return true;
  });
  if (message === undefined) {
    return "Nie";
  }
  let lastTime = orderStore.conversations?.get(message.conversation.id)
    ?.orders_sent?.created_at;
  if (!lastTime) {
    return "Fehler";
  }
  return localeDateString(lastTime);
}
function isConversationSent(conversationId: number) {
  return orderStore.conversations?.get(conversationId)?.orders_sent != null;
}

const hasDeletedMedications = computed<boolean>(() => {
  return (
    Array.from(props.messages).filter(
      (message) =>
        message.medication_order != undefined &&
        message.medication_order.deleted
    ).length > 0
  );
});

const groupedMessagesByPatient = computed<Map<number, Message[]>>(() => {
  const groupedMessages = new Map<number, Message[]>();
  if (props.messages == null) return groupedMessages;

  let messagesArray = Array.from(props.messages)
    .filter(
      (message) =>
        message.medication_order != undefined &&
        (!message.medication_order.deleted || showDeletedMedications.value)
    )
    .sort(
      (a, b) =>
        (a.medication_order?.patient_id ?? 0) -
        (b.medication_order?.patient_id ?? 0)
    );
  messagesArray.forEach((message) => {
    if (message.medication_order != undefined)
      if (
        groupedMessages.get(message.medication_order?.patient_id) == undefined
      ) {
        groupedMessages.set(message.medication_order?.patient_id, []);
      }
    groupedMessages
      .get(message.medication_order?.patient_id ?? -1)
      ?.push(message);
  });
  return new Map(groupedMessages);
});

const boxes = computed<Message[]>(() => {
  return (
    props.messages.filter((message) => message.type == MessageType.box) ?? []
  );
});

const boxOptions = computed<Array<{ name: string; id: number }>>(() => {
  let array: Array<{ name: string; id: number }> = [];
  for (let box of boxes.value) {
    if (box.medication_box?.deleted) continue;
    array.push({
      name: box.medication_box?.name ?? "unbenannte Kiste",
      id: box.id,
    });
  }
  return array;
});

function jsonstringToMedicationFormJson(medicationstring: string) {
  let json = JSON.parse(medicationstring) as OrderMedication;
  json.medicationObject = {
    pharmacode: json.pharmacode,
    gtin: json.gtin,
    dscrd: json.name,
    nincd: json.nincd ?? -2,
    public_price: json.public_price,
    storage_quantity: json.storage_quantity,
  };
  return json;
}

function addMedication() {
  showMedicationModal.value = true;
  editMedicationId.value = undefined;
  medicationForm.value = {};
}

function dialogCardIsReady() {
  // Set up an EventListener to automatically set the storage location for medications that require cool storage
  const medicationObjectInput = getNode("medicationObject");
  const storageLocationInput = getNode("storage_location");

  medicationObjectInput?.on("commit", ({ payload }) => {
    if (medicationObjectInput?.value?.cool_storage) {
      storageLocationInput?.input(storageLocation.find((sl) => sl.id === 1));
    } else {
      storageLocationInput?.input(storageLocation.find((sl) => sl.id === 0));
    }
  });
}

async function copyMedication(medication: BaseMedication) {
  editMedicationId.value = undefined;
  medicationForm.value = medication;
  medicationForm.value.medicationObject = {
    pharmacode: medication.pharmacode,
    gtin: medication.gtin,
    nincd: medication.nincd,
    dscrd: medication.dscrd ?? medication.name,
    public_price: medication.public_price,
    storage_quantity: medication.storage_quantity,
  };
  medicationForm.value.storage_location = storageLocation.find(
    (b) => b.id == (medication.cool_storage ? 1 : 0)
  );

  medicationForm.value.status = undefined;
  medicationForm.value.box = undefined;
  showMedicationModal.value = true;
}

function editMedication(messageId: number) {
  editMedicationId.value = messageId;
  let message = props.messages.find((msg) => msg.id == messageId);
  if (message?.decrypted_message !== undefined) {
    medicationForm.value = jsonstringToMedicationFormJson(
      message?.decrypted_message ?? "{}"
    );
  }

  medicationForm.value.status = medicationOrderStatus.find(
    (b) => b.id == medicationForm.value.status
  );
  medicationForm.value.box = boxOptions.value.find(
    (b) => b.id == medicationForm.value.box
  );
  medicationForm.value.storage_location = storageLocation.find(
    (b) => b.id == medicationForm.value.storage_location
  );
  showMedicationModal.value = true;
}

function getMedicationFromForm(medicationForm: any) {
  let form = medicationForm;
  if (form.medicationObject == undefined) return;

  form.gtin = form.medicationObject.gtin;
  form.name = form.medicationObject.dscrd;
  form.nincd = form.medicationObject.nincd;
  form.status = form.status?.id ?? 0;
  form.amount = parseInt(`${form.amount}`);
  form.deleted = false;
  form.box = form.box?.id;
  form.storage_location =
    form.storage_location?.id ?? (form.medicationObject.cool_storage ? 1 : 0);
  form.pharmacode = form.medicationObject.pharmacode;
  form.storage_quantity = form.medicationObject.storage_quantity;
  form.public_price = form.medicationObject.public_price;
  form.isInIndex = true;
  form.medicationObject = undefined;
  return form;
}

async function saveMedication(medicationForm: any) {
  let id: number | undefined = editMedicationId.value;
  let form = getMedicationFromForm(medicationForm);

  if (!form) return;
  try {
    await saveMessage({
      type: 2,
      id: id,
      decrypted_message: JSON.stringify(form),
    } as MessageModelClass);
    showMedicationModal.value = false;
  } catch (e) {
    console.error(e);
  }
}

async function deleteMedication() {
  let id: number | undefined = editMedicationId.value;
  let form = getMedicationFromForm(medicationForm.value);

  if (!form) return;
  try {
    form.deleted = true;

    await saveMessage({
      type: 2,
      id: id,
      decrypted_message: JSON.stringify(form),
    } as MessageModelClass);
    showMedicationModal.value = false;
  } catch (e) {
    form.deleted = false;
    console.error(e);
  }
}

async function updateMessages(
  message: Message | null,
  _changes: Map<string, any>,
  updateAll?: boolean
) {
  if (message == null) return;
  if (
    message &&
    (selectedMedications.value.get(message.id) != true || updateAll === false)
  ) {
    window._paq.push([
      "trackEvent",
      "OrderMedication",
      "single medication update using dropdown",
      undefined,
    ]);

    loadingMessages.value.add(message.id);
    await updateMessage(props.conversation, message, _changes);
    loadingMessages.value.delete(message.id);
  } else {
    window._paq.push([
      "trackEvent",
      "OrderMedication",
      "bulk update medications using dropdown",
      undefined,
    ]);

    selectedMedications.value.forEach(async (value, key) => {
      if (!value) return;
      let messageWithId = props.messages.find((message) => message.id == key);
      if (messageWithId) {
        loadingMessages.value.add(messageWithId.id);
        updateMessage(props.conversation, messageWithId, _changes).then(() => {
          if (messageWithId) loadingMessages.value.delete(messageWithId.id);
        });
      }
    });
  }
}

async function send() {
  await supabase
    .from("orders_sent")
    .insert({
      conversation_id: props.conversation.id,
    })
    .select();

  window._paq.push(["trackEvent", "Conversation", "send", undefined]);

  confirmSendDraft.value = false;
}

// proPharma
const imported = computed<boolean>(() => {
  if (props.conversation.orders_conversation_status.length > 0) {
    return props.conversation.orders_conversation_status[0].ftp_upload;
  }
  return false;
});

async function exportOrderToPropharma() {
  let ftp = sessionStore.ftp;
  if (ftp == null) return;
  const patients = managedPatientsStore.patientsMap;
  showDeletedMedications.value = false;
  const sortedMessages = groupedMessagesByPatient.value;
  if (!patients) return;
  const csv = buildCsvFromSortedOrders(
    props.conversation.id,
    sortedMessages,
    patients,
    props.conversation.senderCareProviderGroup
  );

  await supabase.functions.invoke("uploadFileToFtp", {
    body: {
      host: ftp.host,
      username: ftp.username,
      password: ftp.password,
      fileContents: csv,
      conversationId: props.conversation.id,
      careProviderGroupId: sessionStore.selectedCareProviderGroup?.id,
    },
  });

  window._paq.push([
    "trackEvent",
    "Conversation",
    "ProPharma-Import",
    undefined,
  ]);
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(UmanaHeadline, {
        h: "h2",
        class: "mb-l flex-shrink-0"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Bestellung")
        ]),
        _: 1
      }),
      (!_ctx.isSender)
        ? (_openBlock(), _createBlock(IconButton, {
            key: 0,
            icon: "scan-barcode",
            label: "Medikamente Kisten zuordnen",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(scannerOn) //@ts-ignore
 ? scannerOn.value = true : scannerOn = true))
          }))
        : _createCommentVNode("", true)
    ]),
    (groupedMessagesByPatient.value.size == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(EmptyContainer, null, {
            default: _withCtx(() => [
              _createTextVNode(" Keine Medikamente erfasst ")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedMessagesByPatient.value.keys(), (patient) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: `patient_${patient ?? -1}`
      }, [
        _createVNode(UmanaHeadline, {
          h: "h3",
          class: "mb-s mt-s",
          "primary-color": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_unref(patientString)(patient)), 1),
            (patient != 0)
              ? (_openBlock(), _createBlock(LabelButton, {
                  key: 0,
                  icon: "right",
                  label: "",
                  onClick: ($event: any) => (
          _ctx.$router.push({
            name: 'managedPatient',
            params: { id: patient },
          })
        )
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: hasAllMedicationSelectedOf(patient),
                onClick: ($event: any) => (selectPatient($event, patient)),
                id: patient.toString(),
                ref_for: true,
                ref_key: "medicationGroups",
                ref: medicationGroups
              }, null, 8, _hoisted_6)
            ]),
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            (!_ctx.isSender)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Status"))
              : _createCommentVNode("", true),
            (!_ctx.isSender)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Lagerort "))
              : _createCommentVNode("", true),
            (!_ctx.isSender)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Kiste"))
              : _createCommentVNode("", true),
            _hoisted_14,
            _hoisted_15
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedMessagesByPatient.value.get(patient ?? -1), (message) => {
            return (_openBlock(), _createElementBlock("div", {
              key: message.id,
              class: _normalizeClass(["flex items-center", {
          'opacity-50': message.medication_order?.deleted,
          'stroke-div': message.medication_order?.deleted,
          'bg-green-4': message.medication_order?.status == 5,
          'bg-red-4': message.medication_order?.status == 6,
        }])
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(ProgressDot, {
                  progress: 
              _unref(medicationOrderStatus).find(
                (b) => b.id == message.medication_order?.status
              )?.progress ?? -1
            
                }, null, 8, ["progress"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: selectedMedications.value.get(message.id) ?? false,
                  onClick: ($event: any) => (selectMedication($event, message)),
                  id: message.id.toString(),
                  ref_for: true,
                  ref_key: "medications",
                  ref: medications
                }, null, 8, _hoisted_18)
              ]),
              _createElementVNode("div", _hoisted_19, _toDisplayString(message.medication_order?.amount) + "x ", 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("p", {
                  class: _normalizeClass(["line-clamp-1 hover:line-clamp-none", { 'line-through': message.medication_order?.deleted }])
                }, _toDisplayString(message.medication_order?.name), 3),
                (message.medication_order?.gtin !== 0)
                  ? (_openBlock(), _createBlock(MedicationInformation, {
                      key: 0,
                      medication: message.medication_order,
                      "is-loading": props.isLoadingMedicationInformation,
                      error: props.errorLoadingMedicationInformation,
                      "as-list": true
                    }, null, 8, ["medication", "is-loading", "error"]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_21, "Freitextmedikament"))
              ]),
              _createElementVNode("div", _hoisted_22, _toDisplayString(message.medication_order?.amount), 1),
              _createElementVNode("div", _hoisted_23, _toDisplayString(message.medication_order?.comment), 1),
              _createElementVNode("div", _hoisted_24, [
                (patient != -1 && message.medication_order)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(lastOrdered(patient, message.medication_order.name)), 1))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.isSender)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(ReactiveSelect, {
                      onChange: ($event: any) => (
              updateMessages(
                message,
                new Map([['status', parseInt($event?.id) ?? 0]])
              )
            ),
                      "allow-empty": false,
                      value: 
              _unref(medicationOrderStatus).find(
                (b) => b.id == message.medication_order?.status
              )
            ,
                      selectOptions: _unref(medicationOrderStatus),
                      "option-label": "name",
                      "divack-by": "id",
                      loading: loadingMessages.value.has(message.id),
                      placeholder: "Status wählen",
                      disabled: message.medication_order?.deleted
                    }, null, 8, ["onChange", "value", "selectOptions", "loading", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isSender)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(ReactiveSelect, {
                      onChange: ($event: any) => (
              updateMessages(
                message,
                new Map([['storage_location', parseInt($event?.id) ?? 0]])
              )
            ),
                      "allow-empty": false,
                      value: 
              _unref(storageLocation).find(
                (b) => b.id == message.medication_order?.storage_location
              )
            ,
                      selectOptions: _unref(storageLocation),
                      "option-label": "name",
                      "divack-by": "id",
                      loading: loadingMessages.value.has(message.id),
                      placeholder: "Lagerort wählen",
                      disabled: message.medication_order?.deleted
                    }, null, 8, ["onChange", "value", "selectOptions", "loading", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isSender && message.medication_order)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(ReactiveSelect, {
                      "allow-empty": false,
                      onChange: ($event: any) => (
              updateMessages(
                message,
                new Map([['box', parseInt($event?.id) ?? 0]])
              )
            ),
                      value: 
              boxOptions.value.find((b) => b.id == message.medication_order?.box)
            ,
                      selectOptions: boxOptions.value,
                      "option-label": "name",
                      "divack-by": "id",
                      disabled: message.medication_order?.deleted,
                      loading: loadingMessages.value.has(message.id),
                      "after-list": "Kisten verwalten",
                      reset: "Keine Kiste",
                      placeholder: "Kiste wählen",
                      onAfterList: _cache[1] || (_cache[1] = ($event: any) => (showBoxModal.value = true))
                    }, null, 8, ["onChange", "value", "selectOptions", "disabled", "loading"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_29, _toDisplayString(message.medication_order?.note), 1),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  (!_ctx.isSender || _ctx.conversation?.orders_sent == null)
                    ? (_openBlock(), _createBlock(CoreIcon, {
                        key: 0,
                        onClick: ($event: any) => (editMedication(message.id)),
                        icon: "pen"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Bearbeiten ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(CoreIcon, {
                    onClick: ($event: any) => (showHistoryOf.value = message),
                    class: "hidden @5xl:block ml-xs",
                    icon: "changeLog"
                  }, null, 8, ["onClick"]),
                  (
                (!_ctx.isSender || _ctx.conversation?.orders_sent == null) &&
                message?.medication_order?.status !== 5 &&
                message?.medication_order?.status !== 6
              )
                    ? (_openBlock(), _createBlock(CoreIcon, {
                        key: 1,
                        onClick: ($event: any) => (updateMessages(message, new Map([['status', 5]]))),
                        icon: "check",
                        class: "ml-xs"
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2))
          }), 128))
        ])
      ], 64))
    }), 128)),
    (hasDeletedMedications.value)
      ? (_openBlock(), _createBlock(LabelButton, {
          key: 1,
          class: "!justify-end !mb-m !mt-xl",
          icon: "changeLog",
          label: 
      !showDeletedMedications.value ? 'Gelöschte anzeigen' : 'Gelöschte verbergen'
    ,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showDeletedMedications.value = !showDeletedMedications.value))
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _createVNode(RoundedCard, {
      color: "gray",
      class: "mt-s md:flex justify-between"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(UmanaHeadline, { h: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(" Status ")
            ]),
            _: 1
          }),
          _createVNode(SmallTag, {
            class: "mx-s w-tag",
            color: _unref(statusOfConversation)(_ctx.conversation, allMessages.value).color
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(statusOfConversation)(_ctx.conversation, allMessages.value).label), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _createElementVNode("div", _hoisted_33, [
          (!_ctx.isSender || _ctx.conversation?.orders_sent == null)
            ? (_openBlock(), _createBlock(UButton, {
                key: 0,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showFavoriteMedicationModal.value = true)),
                class: "mr-xs"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Meine Produkte ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isSender || _ctx.conversation?.orders_sent == null)
            ? (_openBlock(), _createBlock(UButton, {
                key: 1,
                onClick: addMedication
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Medikament hinzufügen ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.conversation?.orders_sent == null)
            ? (_openBlock(), _createBlock(UButton, {
                key: 2,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (confirmSendDraft.value = true)),
                color: "orange",
                class: "ml-xs"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Bestellung senden ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isSender && _unref(sessionStore).ftp)
            ? (_openBlock(), _createBlock(UButton, {
                key: 3,
                onClick: exportOrderToPropharma,
                color: imported.value ? 'white' : 'green',
                class: "ml-xs"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(imported.value ? "Erneut an ProPharma senden" : "An ProPharma senden"), 1)
                ]),
                _: 1
              }, 8, ["color"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(DialogCard, {
      "show-footer": false,
      "is-visible": showFavoriteMedicationModal.value,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (showFavoriteMedicationModal.value = false)),
      title: "Meine Produkte"
    }, {
      default: _withCtx(() => [
        _createVNode(OrderMedicationFavorites, {
          onAddMedication: copyMedication,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (showFavoriteMedicationModal.value = false)),
          filterPatients: patientOptions.value,
          "exclude-order-id": props.conversation.id,
          conversation: props.conversation
        }, null, 8, ["filterPatients", "exclude-order-id", "conversation"])
      ]),
      _: 1
    }, 8, ["is-visible"]),
    (showMedicationModal.value)
      ? (_openBlock(), _createBlock(DialogCard, {
          key: 2,
          "show-footer": false,
          title: "Medikament hinzufügen",
          "is-visible": showMedicationModal.value,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (showMedicationModal.value = false)),
          onIsReady: dialogCardIsReady
        }, {
          default: _withCtx(() => [
            _createVNode(RoundedCard, { color: "gray" }, {
              default: _withCtx(() => [
                _createVNode(_component_FormKit, {
                  type: "form",
                  id: "medicationForm",
                  onSubmit: saveMedication,
                  modelValue: medicationForm.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((medicationForm).value = $event)),
                  actions: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FormKit, {
                      type: "select",
                      label: "Patient",
                      name: "patient_id",
                      options: patientOptions.value
                    }, null, 8, ["options"]),
                    _createVNode(_component_FormKit, {
                      type: "medicationselect",
                      label: "Medikamentenname",
                      name: "medicationObject",
                      id: "medicationObject",
                      validation: "required",
                      patient: medicationForm.value.patient_id,
                      shopCareProviderGroupId: 
            props.conversation.receiverCareProviderGroup.id
          
                    }, null, 8, ["patient", "shopCareProviderGroupId"]),
                    _createVNode(_component_FormKit, {
                      type: "numberinput",
                      label: "Menge",
                      name: "amount",
                      min: 0,
                      validation: "required|number"
                    }),
                    (!_ctx.isSender)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 0,
                          type: "multiselect",
                          "allow-empty": false,
                          selectOptions: _unref(medicationOrderStatus),
                          "option-label": "name",
                          name: "status",
                          "divack-by": "id",
                          label: "Status",
                          placeholder: "Status wählen"
                        }, null, 8, ["selectOptions"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSender)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 1,
                          type: "multiselect",
                          "allow-empty": false,
                          selectOptions: _unref(storageLocation),
                          "option-label": "name",
                          name: "storage_location",
                          id: "storage_location",
                          "divack-by": "id",
                          label: "Lagerort",
                          placeholder: "Lagerort wählen"
                        }, null, 8, ["selectOptions"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSender)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 2,
                          type: "multiselect",
                          "allow-empty": false,
                          selectOptions: boxOptions.value,
                          "option-label": "name",
                          name: "box",
                          label: "Kiste",
                          "divack-by": "id",
                          "after-list": "Kisten verwalten",
                          reset: "Keine Kiste",
                          placeholder: "Kiste wählen",
                          onAfterList: _cache[7] || (_cache[7] = ($event: any) => (showBoxModal.value = true))
                        }, null, 8, ["selectOptions"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSender)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 3,
                          type: "text",
                          label: "Kommentar",
                          name: "comment"
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.isSender)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 4,
                          type: "text",
                          label: "Notiz",
                          name: "note"
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_FormKit, {
                        type: "checkbox",
                        label: "Gelöscht",
                        name: "deleted",
                        class: "hidden",
                        validation: "boolean"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      (editMedicationId.value)
                        ? (_openBlock(), _createBlock(UButton, {
                            key: 0,
                            type: "button",
                            label: "Löschen",
                            color: "red",
                            big: true,
                            class: "w-full",
                            onClick: deleteMedication
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Löschen ")
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_FormKit, {
                            key: 1,
                            type: "button",
                            label: "Abbrechen",
                            class: "bg-white",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (showMedicationModal.value = false))
                          })),
                      _hoisted_36,
                      _createVNode(_component_FormKit, {
                        type: "submit",
                        label: 
              medicationForm.value.deleted
                ? 'Eintrag wiederherstellen'
                : 'Eintrag speichern'
            
                      }, null, 8, ["label"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-visible"]))
      : _createCommentVNode("", true),
    _createVNode(DialogCard, {
      "show-footer": false,
      "is-visible": showBoxModal.value,
      onClose: _cache[12] || (_cache[12] = ($event: any) => (showBoxModal.value = false)),
      title: "Kisten verwalten"
    }, {
      default: _withCtx(() => [
        _createVNode(OrderBoxManagement, {
          messages: props.messages,
          conversation: props.conversation,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (showBoxModal.value = false))
        }, null, 8, ["messages", "conversation"])
      ]),
      _: 1
    }, 8, ["is-visible"]),
    _createVNode(OrderMessageHistory, {
      "of-message": showHistoryOf.value,
      onClose: _cache[13] || (_cache[13] = ($event: any) => (showHistoryOf.value = null)),
      boxes: boxes.value,
      type: "medication"
    }, null, 8, ["of-message", "boxes"]),
    _createVNode(DialogCard, {
      "is-visible": false,
      title: "Scanner",
      "show-footer": false
    }, {
      default: _withCtx(() => [
        _createVNode(BarcodeScanner, {
          "care-provider-group-id": props.conversation.receiverCareProviderGroup.id
        }, null, 8, ["care-provider-group-id"])
      ]),
      _: 1
    }),
    _createVNode(DialogCard, {
      "is-visible": confirmSendDraft.value,
      onClose: _cache[14] || (_cache[14] = ($event: any) => (confirmSendDraft.value = false)),
      title: "Bestellung senden",
      "show-footer": true,
      onSubmit: send,
      confirm: "Bestellung senden"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Sobald Sie Ihre Bestellung abgeschickt haben, können Sie die Bestellung nicht mehr bearbeiten. ")
      ]),
      _: 1
    }, 8, ["is-visible"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_unref(scannerOn))
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createVNode(OrderMessageMedicationBoxScanner, {
              boxes: boxes.value,
              conversation: props.conversation,
              messages: props.messages,
              onClose: _cache[15] || (_cache[15] = ($event: any) => (_isRef(scannerOn) //@ts-ignore
 ? scannerOn.value = false : scannerOn = false))
            }, null, 8, ["boxes", "conversation", "messages"])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})